<template>
  <div>
    <!-- <div id="flex1"></div> -->
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              class="buttonColor"
              depressed
              @click="(dialogAdd = true)"
            >
              <v-icon left>mdi-plus-box-multiple</v-icon>
              เพิ่มกิจกรรม
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <!-- ADD -->
          <v-dialog v-model="dialogAdd" persistent max-width="40%" >
            <v-card>
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <div style="text-align: end">
                      <!-- <div
                          ><h2 style="color: #1b437c;
                          font-weight: bold;
                          margin-bottom: 20px;
                          padding-left: 7px;letter-spacing: 2px;">เพิ่มกิจกรรม</h2></div> -->
                      <div>
                        <v-btn
                          small
                          fab
                          color="#E0E0E0"
                          @click="(dialogAdd = false), clearDataAdd()"
                        >
                          <v-icon color="#FE4A01">mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>
                    <v-row justify="center">
                      <v-col cols="12">
                        <div>
                          <h5
                            style="
                              color: #1b437c;
                              font-weight: bold;
                              margin-bottom: 20px;
                              padding-left: 0;
                              font-weight: bold;
                            "
                          >
                            เลือกรูปแบบกิจกรรม
                          </h5>
                          <v-row class="mb-5">
                            <v-col
                              v-for="(item, i) in session.data.shopId ===
                              'Uc520945108b983b6e739ed0a8cd8dae4'
                                ? selectType
                                : selectType.filter((a) => a.text !== 'วิดีโอ')"
                              :key="i"
                            >
                              <v-card
                                elevation="0"
                                @click="
                                  (formAdd.type = item.value), changColor(item)
                                "
                                :class="
                                  formAdd.type === item.value
                                    ? 'activeCard'
                                    : 'not-activeCard'
                                "
                              >
                                <v-icon :color="item.color" class="iconja">{{
                                  item.icon
                                }}</v-icon>
                                <h6
                                  :style="
                                    formAdd.type === item.value
                                      ? 'font-weight: bold;color:#1b437c;'
                                      : 'font-weight: bold;color: grey;'
                                  "
                                  class="mb-0"
                                >
                                  {{ item.text }}
                                </h6>
                              </v-card>
                            </v-col>
                          </v-row>
                        </div>
                        <!-- เลือกรูปแบบตอบคำถาม -->
                        <div v-if="formAdd.type === 'กรอกข้อมูล'">
                          <h5
                            style="
                              color: #1b437c;
                              font-weight: bold;
                              margin-bottom: 0px;
                              font-weight: bold;
                            "
                          >
                            เลือกรูปแบบคำตอบ
                          </h5>
                          <v-row style="display: flex; justify-content: center">
                            <v-col cols="10">
                              <v-select
                                background-color="#f2f4f9"
                                v-model="formAdd.answerType"
                                :items="answerTypeList"
                                :menu-props="{ bottom: true, offsetY: true }"
                                label="คำตอบ"
                                hide-details
                                attach
                                outlined
                                dense
                                prepend-icon="mdi-forum"
                              ></v-select>
                            </v-col>
                          </v-row>
                          <v-card
                            v-if="formAdd.answerType === 'คำตอบแบบข้อความ'"
                            elevation="0"
                            class="pa-4"
                            style="
                              border-radius: 15px !important;
                              text-align: center;
                              border: 2px solid #eee;
                            "
                          >
                            <v-card-text>
                              <div style="display: flex">
                                <h4 style="color: red">*</h4>
                                <h4
                                  class="ml-3"
                                  style="
                                    height: 20px;
                                    font-weight: bold;
                                    text-align: left;
                                  "
                                >
                                  คำถามที่ 1
                                </h4>
                              </div>
                              <v-row>
                                <v-col
                                  class="mt pa-0"
                                  cols="12"
                                  style="height: 75px"
                                >
                                  <v-text-field
                                    class="pb-0"
                                    background-color="#f2f4f9"
                                    v-model="formAdd.field1Title"
                                    placeholder="ชื่อข้อมูล"
                                    :rules="required"
                                    label="ชื่อข้อมูล"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" class="pa-0">
                                  <v-select
                                    class="pt-0"
                                    background-color="#f2f4f9"
                                    v-model="formAdd.field1Type"
                                    :items="selectTypeField"
                                    :rules="required"
                                    placeholder="ประเภทกรอกข้อมูล"
                                    label="ประเภทการกรอกข้อมูล"
                                    outlined
                                    dense
                                    :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                    }"
                                  ></v-select>
                                </v-col>
                                <v-row
                                  class="ml-5"
                                  v-if="
                                    formAdd.field1Title !== '' &&
                                    formAdd.field1Type !== ''
                                  "
                                >
                                  <v-col>
                                    <v-row style="height: 15px">
                                      <v-subheader id="subtext"
                                        >PRIMARY
                                      </v-subheader>
                                    </v-row>
                                    <v-row style="height: 60px">
                                      <v-switch
                                        v-model="formAdd.Primary_field"
                                        color="primary"
                                        placeholder="Primary"
                                        value="1"
                                      ></v-switch>
                                    </v-row>
                                  </v-col>
                                  <v-col>
                                    <v-checkbox
                                      v-model="formAdd.chkbox1"
                                      label="บังคับกรอกข้อมูล"
                                    >
                                    </v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-row>
                            </v-card-text>
                            <v-card-text v-if="countQuestion >= 2">
                              <div
                                style="
                                  display: flex;
                                  justify-content: space-between;
                                "
                              >
                                <h4
                                  class="ml-3"
                                  style="
                                    height: 20px;
                                    font-weight: bold;
                                    text-align: left;
                                  "
                                >
                                  คำถามที่ 2
                                </h4>
                                <v-btn
                                  fab
                                  small
                                  color="red"
                                  dark
                                  @click="clearData2(), countQuestion--"
                                  ><v-icon dark>mdi-minus</v-icon></v-btn
                                >
                              </div>
                              <v-row>
                                <v-col
                                  class="mt pa-0"
                                  cols="12"
                                  style="height: 75px"
                                >
                                  <v-text-field
                                    class="pb-0"
                                    background-color="#f2f4f9"
                                    v-model="formAdd.field2Title"
                                    placeholder="ชื่อข้อมูล"
                                    label="ชื่อข้อมูล"
                                    outlined
                                    hide-details
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" class="pa-0">
                                  <v-select
                                    class="pt-0"
                                    background-color="#f2f4f9"
                                    v-model="formAdd.field2Type"
                                    :items="selectTypeField"
                                    placeholder="ประเภทกรอกข้อมูล"
                                    label="ประเภทการกรอกข้อมูล"
                                    outlined
                                    dense
                                    :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                    }"
                                  ></v-select>
                                </v-col>
                                <v-row
                                  class="ml-5"
                                  v-if="
                                    formAdd.field2Title !== '' &&
                                    formAdd.field2Type !== ''
                                  "
                                >
                                  <v-col>
                                    <v-row style="height: 15px">
                                      <v-subheader id="subtext"
                                        >PRIMARY
                                      </v-subheader>
                                    </v-row>
                                    <v-row style="height: 60px">
                                      <v-switch
                                        v-model="formAdd.Primary_field"
                                        color="primary"
                                        placeholder="Primary"
                                        value="2"
                                      ></v-switch>
                                    </v-row>
                                  </v-col>
                                  <v-col>
                                    <v-checkbox
                                      v-model="formAdd.chkbox2"
                                      label="บังคับกรอกข้อมูล"
                                    >
                                    </v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-row>
                            </v-card-text>
                            <v-card-text v-if="countQuestion >= 3">
                              <div
                                style="
                                  display: flex;
                                  justify-content: space-between;
                                "
                              >
                                <h4
                                  class="ml-3"
                                  style="
                                    height: 20px;
                                    font-weight: bold;
                                    text-align: left;
                                  "
                                >
                                  คำถามที่ 3
                                </h4>
                                <v-btn
                                  fab
                                  small
                                  color="red"
                                  dark
                                  @click="clearData3(),countQuestion--"
                                  ><v-icon dark>mdi-minus</v-icon></v-btn
                                >
                              </div>
                              <v-row>
                                <v-col
                                  class="mt pa-0"
                                  cols="12"
                                  style="height: 75px"
                                >
                                  <v-text-field
                                    class="pb-0"
                                    background-color="#f2f4f9"
                                    v-model="formAdd.field3Title"
                                    placeholder="ชื่อข้อมูล"
                                    label="ชื่อข้อมูล"
                                    outlined
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" class="pa-0">
                                  <v-select
                                    class="pt-0"
                                    background-color="#f2f4f9"
                                    v-model="formAdd.field3Type"
                                    :items="selectTypeField"
                                    placeholder="ประเภทกรอกข้อมูล"
                                    label="ประเภทการกรอกข้อมูล"
                                    outlined
                                    :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                    }"
                                    dense
                                  ></v-select>
                                </v-col>
                                <v-row
                                  class="ml-5"
                                  v-if="
                                    formAdd.field3Title !== '' &&
                                    formAdd.field3Type !== ''
                                  "
                                >
                                  <v-col>
                                    <v-row style="height: 15px">
                                      <v-subheader id="subtext"
                                        >PRIMARY
                                      </v-subheader>
                                    </v-row>
                                    <v-row style="height: 60px">
                                      <v-switch
                                        v-model="formAdd.Primary_field"
                                        color="primary"
                                        placeholder="Primary"
                                        value="3"
                                      ></v-switch>
                                    </v-row>
                                  </v-col>
                                  <v-col>
                                    <v-checkbox
                                      v-model="formAdd.chkbox3"
                                      label="บังคับกรอกข้อมูล"
                                    >
                                    </v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-row>
                            </v-card-text>
                            <v-card-text v-if="countQuestion >= 4">
                              <div
                                style="
                                  display: flex;
                                  justify-content: space-between;
                                "
                              >
                                <h4
                                  class="ml-3"
                                  style="
                                    height: 20px;
                                    font-weight: bold;
                                    text-align: left;
                                  "
                                >
                                  คำถามที่ 4
                                </h4>
                                <v-btn
                                  fab
                                  small
                                  color="red"
                                  dark
                                  @click="countQuestion--, clearData4()"
                                  ><v-icon dark>mdi-minus</v-icon></v-btn
                                >
                              </div>
                              <v-row>
                                <v-col
                                  class="mt pa-0"
                                  cols="12"
                                  style="height: 75px"
                                >
                                  <v-text-field
                                    background-color="#f2f4f9"
                                    v-model="formAdd.field4Title"
                                    placeholder="ชื่อข้อมูล"
                                    label="ชื่อข้อมูล"
                                    outlined
                                    hide-details
                                    dense
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" class="pa-0">
                                  <v-select
                                    class="pt-0"
                                    background-color="#f2f4f9"
                                    v-model="formAdd.field4Type"
                                    :items="selectTypeField"
                                    placeholder="ประเภทกรอกข้อมูล"
                                    :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                    }"
                                    label="ประเภทการกรอกข้อมูล"
                                    outlined
                                    hide-details
                                    dense
                                  ></v-select> </v-col
                                ><v-row
                                  class="ml-5"
                                  v-if="
                                    formAdd.field4Title !== '' &&
                                    formAdd.field4Type !== ''
                                  "
                                >
                                  <v-col>
                                    <v-row style="height: 15px">
                                      <v-subheader id="subtext"
                                        >PRIMARY
                                      </v-subheader>
                                    </v-row>
                                    <v-row style="height: 60px">
                                      <v-switch
                                        v-model="formAdd.Primary_field"
                                        color="primary"
                                        placeholder="Primary"
                                        value="4"
                                      ></v-switch>
                                    </v-row>
                                  </v-col>
                                  <v-col>
                                    <v-checkbox
                                      v-model="formAdd.chkbox4"
                                      label="บังคับกรอกข้อมูล"
                                    >
                                    </v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-row>
                            </v-card-text>
                            <v-btn
                              block
                              color="black"
                              dark
                              style="border-radius: 10px"
                              :disabled="countQuestion === 4"
                              @click="countQuestion++"
                              >เพิ่มคำถาม</v-btn
                            >
                            <v-divider></v-divider>
                            <div>
                              <h5 style="font-weight: bold; color: #1b437c">
                                ข้อมูลกิจกรรม
                              </h5>
                              <v-col
                                cols="12"
                                style="display: flex; justify-content: center"
                              >
                                <v-card
                                  @click="chooseImage"
                                  class="image-input"
                                  :style="{
                                    'background-image': `url(${formAdd.pictureUrlPreview})`,
                                    'background-size': 'contain',
                                    'background-position': 'center center',
                                    'background-repeat': 'no-repeat',
                                  }"
                                >
                                  <!-- <span
                                      v-if="formAdd.pictureUrlPreview === ''"
                                      class="placeholder"
                                    >
                                      Choose an Image
                                    </span>
                                   <v-file-input
                                  style="display: none;"
                                  class="pa-0"
                                  required
                                  counter
                                  show-size
                                  ref="fileInput"
                                  accept="image/png, image/jpeg, image/bmp"
                                  prepend-icon="mdi-camera"
                                  label="Image"
                                  @change="selectImg"
                                  v-model="filesAdd"
                                ></v-file-input> -->
                                  <span
                                    v-if="formAdd.pictureUrlPreview === ''"
                                    class="placeholder"
                                  >
                                    Choose an Image
                                  </span>
                                  <input
                                    style="display: none"
                                    class="file-input"
                                    ref="fileInput"
                                    type="file"
                                    @input="onSelectFile"
                                  />
                                </v-card>
                                <!-- <v-img
                                  style="background-color:red;"
                                  aspect-ratio="6"
                                  contain
                                  :src="formAdd.pictureUrlPreview"
                                ></v-img>
                                <br />
                                <v-file-input
                                  class="pa-0"
                                  required
                                  counter
                                  show-size
                                  accept="image/png, image/jpeg, image/bmp"
                                  prepend-icon="mdi-camera"
                                  label="Image"
                                  @change="selectImg"
                                  v-model="filesAdd"
                                ></v-file-input> -->
                              </v-col>
                              <v-text-field
                                class="pa-0"
                                background-color="#f2f4f9"
                                v-model="formAdd.title"
                                label="ชื่อกิจกรรม"
                                placeholder="ชื่อกิจกรรม"
                                :rules="required"
                                outlined
                                dense
                              ></v-text-field>
                            </div>
                            <div>
                              <v-row>
                                <v-col cols="6">
                                  <v-menu
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        class="pa-0"
                                        background-color="#f2f4f9"
                                        v-model="formAdd.startDate"
                                        placeholder="วันที่เริ่ม"
                                        prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                        label="วันที่เริ่ม"
                                        :rules="required"
                                        outlined
                                        dense
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="formAdd.startDate"
                                      @input="menu = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="6">
                                  <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        class="pa-0"
                                        v-model="formAdd.endDate"
                                        placeholder="วันที่สิ้นสุด"
                                        background-color="#f2f4f9"
                                        prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                        :rules="required"
                                        dense
                                        label="วันที่สิ้นสุด"
                                        outlined
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="formAdd.endDate"
                                      @input="menu2 = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                            </div>
                            <div>
                              <v-row>
                                <v-col cols="6" class="pa-0">
                                  <VuetifyMoney
                                    class="pa-0"
                                    background-color="#f2f4f9"
                                    v-model="formAdd.quota"
                                    label="จำกัดจำนวน"
                                    placeholder="จำกัดจำนวน"
                                    outlined
                                    dense
                                    :rules="required"
                                    required
                                    v-bind:options="options2"
                                  />
                                </v-col>
                                <v-col cols="6" class="pa-0">
                                  <VuetifyMoney
                                    class="pa-0"
                                    v-model="formAdd.coin"
                                    background-color="#f2f4f9"
                                    label="เหรียญที่ได้รับ"
                                    placeholder="เหรียญที่ได้รับ"
                                    outlined
                                    dense
                                    :rules="required"
                                    required
                                    v-bind:options="options2"
                                    v-if="formAdd.type != 'LuckyDraw'"
                                  />
                                </v-col>
                              </v-row>
                            </div>
                          </v-card>
                          <!-- คำตอบแบบ 1 ตัวเลือก -->
                          <v-card
                            v-if="formAdd.answerType === 'คำตอบแบบ 1 ตัวเลือก' || formAdd.answerType === 'คำตอบแบบมากกว่า 1 ตัวเลือก'"
                            elevation="0"
                            class="pa-4"
                            style="
                              border-radius: 15px !important;
                              text-align: center;
                              border: 2px solid #eee;
                            "
                          >
                            <v-card-text v-if="loadingInsert === true">
                              <v-progress-circular
                                indeterminate
                                size="64"
                              ></v-progress-circular>
                            </v-card-text>
                            <v-card-text v-if="loadingInsert === false">
                              <div style="text-align: end;">
                                <v-btn rounded small color="green" style="color:white" @click="addQuestion">
                                เพิ่มคำถาม
                                  <v-icon color="white">
                                    mdi-plus
                                  </v-icon>
                                </v-btn>
                              </div>
                              <v-col
                                  v-for="(item, i) in formAdd.answerChoice" :key="i"
                                  class="mt pa-4"
                                  cols="12"
                                  align="center"
                                >
                                <h5 style="text-align: left;font-weight: bold;">คำถามที่ {{i + 1}}</h5>
                                      <v-text-field
                                      v-model="item[0]"
                                      rounded
                                      :rules="required"
                                      class="pa-0 mb-3"
                                      background-color="#f2f4f9"
                                      :placeholder="'คำถามที่ '+ (i + 1)"
                                      :label="'คำถามที่ '+ (i + 1)"
                                      outlined
                                      hide-details
                                      dense
                                      ></v-text-field>
                                      <h6 style="text-align: left;font-weight: bold;padding-left: 35px;">ตัวเลือกคำตอบ</h6>
                                      <div v-for="(item2, index) in item.length - 1" :key="index">
                                         <v-text-field
                                          v-model="item[index + 1]"
                                          prepend-icon="mdi-arrow-right-drop-circle"
                                          append-icon="mdi-close-circle"
                                          class="pa-0 mb-2"
                                          background-color="#f2f4f9"
                                          :rules="required"
                                          :placeholder="'ตัวเลือกที่ '+ (index + 1)"
                                          :label="'ตัวเลือกที่ '+ (index + 1)"
                                          @click:append="toggleMarker(item2, item)"
                                          outlined
                                          hide-details
                                          dense
                                          >
                                          <template>

                                          </template>
                                          </v-text-field>
                                      </div>
                                      <v-btn @click="addChoice(item)">
                                        เพิ่มตัวเลือก
                                      </v-btn>
                                      <v-divider></v-divider>
                              </v-col>
                              <!-- <v-row>
                                <v-col cols="12" class="pa-0">
                                  <v-select
                                    class="pt-0"
                                    background-color="#f2f4f9"
                                    v-model="formAdd.field1Type"
                                    :items="selectTypeField"
                                    placeholder="ประเภทกรอกข้อมูล"
                                    label="ประเภทการกรอกข้อมูล"
                                    outlined
                                    dense
                                    :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                    }"
                                  ></v-select>
                                </v-col>
                                <v-row
                                  class="ml-5"
                                  v-if="
                                    formAdd.field1Title !== '' &&
                                    formAdd.field1Type !== ''
                                  "
                                >
                                  <v-col>
                                    <v-row style="height: 15px">
                                      <v-subheader id="subtext"
                                        >PRIMARY
                                      </v-subheader>
                                    </v-row>
                                    <v-row style="height: 60px">
                                      <v-switch
                                        v-model="formAdd.Primary_field"
                                        color="primary"
                                        placeholder="Primary"
                                        value="1"
                                      ></v-switch>
                                    </v-row>
                                  </v-col>
                                  <v-col>
                                    <v-checkbox
                                      v-model="formAdd.chkbox1"
                                      label="บังคับกรอกข้อมูล"
                                    >
                                    </v-checkbox>
                                  </v-col>
                                </v-row>
                              </v-row> -->
                            </v-card-text>
                            <v-divider v-if="loadingInsert === false"></v-divider>
                            <div v-if="loadingInsert === false">
                              <h3 style="font-weight: bold; color: #1b437c">
                                ข้อมูลกิจกรรม
                              </h3>
                              <v-col
                                cols="12"
                                style="display: flex; justify-content: center"
                              >
                                <v-card
                                  @click="chooseImage"
                                  class="image-input"
                                  :style="{
                                    'background-image': `url(${formAdd.pictureUrlPreview})`,
                                    'background-size': 'contain',
                                    'background-position': 'center center',
                                    'background-repeat': 'no-repeat',
                                  }"
                                >
                                  <!-- <span
                                      v-if="formAdd.pictureUrlPreview === ''"
                                      class="placeholder"
                                    >
                                      Choose an Image
                                    </span>
                                   <v-file-input
                                  style="display: none;"
                                  class="pa-0"
                                  required
                                  counter
                                  show-size
                                  ref="fileInput"
                                  accept="image/png, image/jpeg, image/bmp"
                                  prepend-icon="mdi-camera"
                                  label="Image"
                                  @change="selectImg"
                                  v-model="filesAdd"
                                ></v-file-input> -->
                                  <span
                                    v-if="formAdd.pictureUrlPreview === ''"
                                    class="placeholder"
                                  >
                                    Choose an Image
                                  </span>
                                  <input
                                    style="display: none"
                                    class="file-input"
                                    ref="fileInput"
                                    type="file"
                                    @input="onSelectFile"
                                  />
                                </v-card>
                                <!-- <v-img
                                  style="background-color:red;"
                                  aspect-ratio="6"
                                  contain
                                  :src="formAdd.pictureUrlPreview"
                                ></v-img>
                                <br />
                                <v-file-input
                                  class="pa-0"
                                  required
                                  counter
                                  show-size
                                  accept="image/png, image/jpeg, image/bmp"
                                  prepend-icon="mdi-camera"
                                  label="Image"
                                  @change="selectImg"
                                  v-model="filesAdd"
                                ></v-file-input> -->
                              </v-col>
                              <v-text-field
                                class="pa-0"
                                background-color="#f2f4f9"
                                v-model="formAdd.title"
                                label="ชื่อกิจกรรม"
                                placeholder="ชื่อกิจกรรม"
                                outlined
                                :rules="required"
                                dense
                              ></v-text-field>
                            </div>
                            <div v-if="loadingInsert === false">
                              <v-row>
                                <v-col cols="6">
                                  <v-menu
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        class="pa-0"
                                        background-color="#f2f4f9"
                                        v-model="formAdd.startDate"
                                        placeholder="วันที่เริ่ม"
                                        prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                        label="วันที่เริ่ม"
                                        :rules="required"
                                        outlined
                                        dense
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="formAdd.startDate"
                                      @input="menu = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="6">
                                  <v-menu
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        class="pa-0"
                                        v-model="formAdd.endDate"
                                        placeholder="วันที่สิ้นสุด"
                                        background-color="#f2f4f9"
                                        prepend-inner-icon="mdi-calendar"
                                        v-bind="attrs"
                                        dense
                                        :rules="required"
                                        label="วันที่สิ้นสุด"
                                        outlined
                                        v-on="on"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="formAdd.endDate"
                                      @input="menu2 = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>
                              </v-row>
                            </div>
                            <div v-if="loadingInsert === false">
                              <v-row>
                                <v-col cols="6" class="pa-0">
                                  <VuetifyMoney
                                    class="pa-0"
                                    background-color="#f2f4f9"
                                    v-model="formAdd.quota"
                                    label="จำกัดจำนวน"
                                    placeholder="จำกัดจำนวน"
                                    outlined
                                    dense
                                    :rules="required"
                                    required
                                    v-bind:options="options2"
                                  />
                                </v-col>
                                <v-col cols="6" class="pa-0">
                                  <VuetifyMoney
                                    class="pa-0"
                                    v-model="formAdd.coin"
                                    background-color="#f2f4f9"
                                    label="เหรียญที่ได้รับ"
                                    placeholder="เหรียญที่ได้รับ"
                                    outlined
                                    :rules="required"
                                    dense
                                    required
                                    v-bind:options="options2"
                                    v-if="formAdd.type != 'LuckyDraw'"
                                  />
                                </v-col>
                              </v-row>
                            </div>
                          </v-card>
                        </div>
                        <!-- รับคะแนนฟรี -->
                        <div v-if="formAdd.type === 'FreeCoin'">
                          <v-card
                              elevation="0"
                              class="pa-4"
                              style="
                                border-radius: 15px !important;
                                text-align: center;
                                border: 2px solid #eee;
                              "
                            >
                          <div>
                            <h3 style="font-weight: bold; color: #1b437c">
                              ข้อมูลกิจกรรม
                            </h3>
                            <v-col
                              cols="12"
                              style="display: flex; justify-content: center"
                            >
                              <v-card
                                @click="chooseImage"
                                class="image-input"
                                :style="{
                                  'backgroundImage': 'url(' + formAdd.pictureUrlPreview + ')',
                                  'background-size': 'contain',
                                  'background-position': 'center center',
                                  'background-repeat': 'no-repeat',
                                }"
                              >
                                <span
                                  v-if="formAdd.pictureUrlPreview === ''"
                                  class="placeholder"
                                >
                                  Choose an Image
                                </span>
                                <input
                                  style="display: none"
                                  class="file-input"
                                  ref="fileInput"
                                  type="file"
                                  @input="onSelectFile"
                                />
                              </v-card>
                            </v-col>
                            <v-text-field
                              class="pa-0"
                              background-color="#f2f4f9"
                              v-model="formAdd.title"
                              :rules="required"
                              label="ชื่อกิจกรรม"
                              placeholder="ชื่อกิจกรรม"
                              outlined
                              dense
                            ></v-text-field>
                            <v-col
                              cols="12"
                              class="pa-0"
                              v-if="
                                formAdd.type === 'FreeCoin' ||
                                formAdd.type === 'LuckyDraw' ||
                                formAdd.type === 'video'
                              "
                            >
                              <v-select
                                class="pa-0"
                                v-model="formAdd.repeats"
                                :items="selectRepeat"
                                :rules="required"
                                label="การทำซ้ำ"
                                placeholder="การทำซ้ำ"
                                outlined
                                dense
                              ></v-select>
                            </v-col>
                          </div>
                          <div>
                            <v-row>
                              <v-col cols="6">
                                <v-menu
                                  v-model="menu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      class="pa-0"
                                      background-color="#f2f4f9"
                                      v-model="formAdd.startDate"
                                      placeholder="วันที่เริ่ม"
                                      prepend-inner-icon="mdi-calendar"
                                      v-bind="attrs"
                                      label="วันที่เริ่ม"
                                      :rules="required"
                                      outlined
                                      dense
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="formAdd.startDate"
                                    @input="menu = false"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="6">
                                <v-menu
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      class="pa-0"
                                      v-model="formAdd.endDate"
                                      placeholder="วันที่สิ้นสุด"
                                      background-color="#f2f4f9"
                                      prepend-inner-icon="mdi-calendar"
                                      v-bind="attrs"
                                      dense
                                      :rules="required"
                                      label="วันที่สิ้นสุด"
                                      outlined
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="formAdd.endDate"
                                    @input="menu2 = false"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </div>
                          <div>
                            <v-row>
                              <v-col cols="6" class="pa-0" >
                                <VuetifyMoney
                                  class="pa-0"
                                  background-color="#f2f4f9"
                                  v-model="formAdd.quota"
                                  label="จำกัดจำนวน"
                                  placeholder="จำกัดจำนวน"
                                  :rules="required"
                                  outlined
                                  dense
                                  required
                                  v-bind:options="options2"
                                />
                              </v-col>
                              <v-col cols="6" class="pa-0" >
                                <VuetifyMoney
                                  class="pa-0"
                                  v-model="formAdd.coin"
                                  background-color="#f2f4f9"
                                  label="เหรียญที่ได้รับ"
                                  placeholder="เหรียญที่ได้รับ"
                                  outlined
                                  :rules="required"
                                  dense
                                  required
                                  v-bind:options="options2"
                                  v-if="formAdd.type != 'LuckyDraw'"
                                />
                              </v-col>
                            </v-row>
                          </div>
                          </v-card>
                        </div>
                        <!-- lucky draw -->
                        <div v-if="formAdd.type === 'LuckyDraw'">
                          <v-card
                              elevation="0"
                              class="pa-4"
                              style="
                                border-radius: 15px !important;
                                text-align: center;
                                border: 2px solid #eee;
                              "
                            >
                          <div>
                            <h3 style="font-weight: bold; color: #1b437c">
                              ข้อมูลกิจกรรม
                            </h3>
                            <v-col
                              cols="12"
                              style="display: flex; justify-content: center"
                            >
                              <v-card
                                @click="chooseImage"
                                class="image-input"
                                :style="{
                                  'background-image': `url(${formAdd.pictureUrlPreview})`,
                                  'background-size': 'contain',
                                  'background-position': 'center center',
                                  'background-repeat': 'no-repeat',
                                }"
                              >
                                <span
                                  v-if="formAdd.pictureUrlPreview === ''"
                                  class="placeholder"
                                >
                                  Choose an Image
                                </span>
                                <input
                                  style="display: none"
                                  class="file-input"
                                  ref="fileInput"
                                  type="file"
                                  @input="onSelectFile"
                                />
                              </v-card>
                            </v-col>
                            <v-text-field
                              class="pa-0"
                              background-color="#f2f4f9"
                              v-model="formAdd.title"
                              label="ชื่อกิจกรรม"
                              :rules="required"
                              placeholder="ชื่อกิจกรรม"
                              outlined
                              dense
                            ></v-text-field>
                            <v-col
                              cols="12"
                              class="pa-0"
                              v-if="
                                formAdd.type === 'FreeCoin' ||
                                formAdd.type === 'LuckyDraw' ||
                                formAdd.type === 'video'
                              "
                            >
                              <v-select
                                class="pa-0"
                                v-model="formAdd.repeats"
                                :items="selectRepeat"
                                label="การทำซ้ำ"
                                :rules="required"
                                placeholder="การทำซ้ำ"
                                outlined
                                dense
                              ></v-select>
                            </v-col>
                          </div>
                          <div>
                            <v-row>
                              <v-col cols="6">
                                <v-menu
                                  v-model="menu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      class="pa-0"
                                      background-color="#f2f4f9"
                                      v-model="formAdd.startDate"
                                      placeholder="วันที่เริ่ม"
                                      prepend-inner-icon="mdi-calendar"
                                      v-bind="attrs"
                                      label="วันที่เริ่ม"
                                      :rules="required"
                                      outlined
                                      dense
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="formAdd.startDate"
                                    @input="menu = false"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                              <v-col cols="6">
                                <v-menu
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      class="pa-0"
                                      v-model="formAdd.endDate"
                                      placeholder="วันที่สิ้นสุด"
                                      background-color="#f2f4f9"
                                      prepend-inner-icon="mdi-calendar"
                                      v-bind="attrs"
                                      dense
                                      label="วันที่สิ้นสุด"
                                      :rules="required"
                                      outlined
                                      v-on="on"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="formAdd.endDate"
                                    @input="menu2 = false"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </div>
                          <div>
                            <v-row>
                              <v-col cols="6" class="pa-0">
                                <VuetifyMoney
                                  class="pa-0"
                                  background-color="#f2f4f9"
                                  v-model="formAdd.quota"
                                  label="จำกัดจำนวน"
                                  placeholder="จำกัดจำนวน"
                                  outlined
                                  :rules="required"
                                  dense
                                  required
                                  v-bind:options="options2"
                                />
                              </v-col>
                              <v-col cols="6" class="pa-0" >
                                <VuetifyMoney
                                  class="pa-0"
                                  v-model="formAdd.coin"
                                  background-color="#f2f4f9"
                                  label="เหรียญที่ได้รับ"
                                  placeholder="เหรียญที่ได้รับ"
                                  outlined
                                  dense
                                  :rules="required"
                                  required
                                  v-bind:options="options2"
                                  v-if="formAdd.type != 'LuckyDraw'"
                                />
                              </v-col>
                            </v-row>
                          </div>
                          </v-card>
                        </div>
                        <v-col cols="12">
                          <v-col id="margin">
                            <v-row justify="center">
                              <v-btn
                                class="white--text"
                                elevation="2"
                                x-large
                                block
                                color="#173053"
                                :disabled="!validAdd"
                                :loading="loadingAdd"
                                @click="addData()"
                              >
                                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                                บันทึก
                              </v-btn>
                            </v-row>
                          </v-col>
                        </v-col>
                      </v-col>
                    </v-row></v-container
                  >
                </v-card-text>
              </v-form>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="40%">
            <v-card>
              <v-card-title>
                <span class="headline">แก้ไขข้อมูล</span>
              </v-card-title>
              <v-card-text>
                <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" class="text-center">
                        <v-img
                          aspect-ratio="6"
                          contain
                          :src="formUpdate.pictureUrlPreview"
                        ></v-img>
                        <!-- <v-avatar size="100px"><img alt="Avatar" :src="formAdd.pictureUrl"></v-avatar> -->
                        <br />
                        <v-file-input
                          required
                          counter
                          show-size
                          accept="image/png, image/jpeg, image/bmp"
                          prepend-icon="mdi-camera"
                          label="Image"
                          @change="selectImgUpdate"
                          v-model="filesUpdate"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <v-text-field
                          v-model="formUpdate.title"
                          label="ชื่อกิจกรรม"
                          placeholder="ชื่อกิจกรรม"
                          outlined
                          dense
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  color="#173053"
                  @click="
                    (dialogEdit = false),
                      getDataGlobal(
                        DNS_IP,
                        path,
                        session.data.shopId,
                        returnLink
                      )
                  "
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="#173053"
                  :disabled="!validUpdate"
                  :loading="loadingEdit"
                  @click="editData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  บันทึก
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end edit -->

          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="40%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="formUpdate.title"
                        label="ชื่อกิจกรรม"
                        placeholder="ชื่อกิจกรรม"
                        outlined
                        dense
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn
                  elevation="2"
                  x-large
                  color="red darken-1"
                  @click="deleteData()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end delete -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                  dense
                >
                  <template v-slot:[`item.quota`]="{ item }">
                    {{ formatNumber(item.quota) }}
                  </template>
                  <template v-slot:[`item.countUser`]="{ item }">
                    {{ formatNumber(item.countUser) }}
                  </template>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <!-- <v-btn
                      color="green"
                      fab
                      small
                      @click.stop="
                          sendData(item)
                      "
                    >
                      <v-icon dark> mdi-send-circle </v-icon>
                    </v-btn> -->
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          small
                          @click.stop="
                            (dialogEdit = true),
                              getDataById(item),
                              validate('UPDATE')
                          "
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          small
                          @click.stop="(dialogDelete = true), getDataById(item)"
                        >
                          <v-icon> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import VuetifyMoney from '../VuetifyMoney.vue'
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import QrcodeVue from 'qrcode.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    QrcodeVue
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/activity/', // Path Model
      returnLink: '/Tool/Activity',
      // Menu Config
      countQuestion: 1,
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'Activity',
          disabled: false,
          href: '/Tool/Activity'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      selectTypeField: [
        { text: 'Text', value: 'text' },
        { text: 'Number', value: 'number' },
        { text: 'Datetime', value: 'dateTime' },
        { text: 'Email', value: 'email' },
        { text: 'CitizenNumber', value: 'citizenNumber' }
      ],
      selectType: [
        {
          text: 'ตอบคำถามรับคะแนน',
          value: 'กรอกข้อมูล',
          icon: 'mdi-message-question',
          color: '#1b437c'
        },
        {
          text: 'รับคะแนน ฟรี!',
          value: 'FreeCoin',
          icon: 'mdi-alpha-c-circle-outline',
          color: 'grey'
        },
        {
          text: 'วิดีโอ',
          value: 'video',
          icon: 'mdi-play-box-multiple',
          color: 'grey'
        },
        {
          text: 'Lucky Draw',
          value: 'LuckyDraw',
          icon: 'mdi-dice-multiple',
          color: 'grey'
        }
      ],
      selectRepeat: [
        { text: 'ครั้งเดียว', value: 'OneTime' },
        { text: 'ทุกวัน', value: 'Daily' },
        { text: 'ทุกสัปดาห์', value: 'Weekly' },
        { text: 'ทุกเดือน', value: 'Monthly' }
      ],
      camera: 'auto',
      result: null,
      activityType: 'ตอบคำถามรับคะแนน',
      showScanConfirmation: false,
      // End Menu Config
      dataReady: true,
      dataShowQR: false,
      dialogRedeem: false,
      size: 150, // QR Code
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      dialogViewLot: false,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogSend: false,
      dialogAdd: false,
      dialogAddLot: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogView: false,
      dialogViewAdd: false,
      dialogDoc: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0, 1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      filesAdd: null,
      filesUpdate: null,
      formAdd: {
        activityId: '',
        title: '',
        type: 'กรอกข้อมูล',
        answerType: 'คำตอบแบบข้อความ',
        repeats: '',
        startDate: '',
        endDate: '',
        quota: '',
        coin: 0,
        field1Title: '',
        answerChoice: [['', '', '']],
        field1Type: '',
        field2Title: '',
        field2Type: '',
        field3Title: '',
        field3Type: '',
        field4Title: '',
        field4Type: '',
        Primary_field: '',
        chkbox1: false,
        chkbox2: false,
        chkbox3: false,
        chkbox4: false,
        shopId: '',
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrl: '',
        pictureUrlPreview: ''
      },
      formUpdate: {
        activityId: '',
        title: '',
        type: '',
        repeats: '',
        startDate: '',
        endDate: '',
        quota: '',
        coin: 0,
        field1Title: '',
        field1Type: '',
        field2Title: '',
        field2Type: '',
        field3Title: '',
        field3Type: '',
        field4Title: '',
        field4Type: '',
        Primary_field: '',
        shopId: '',
        CREATE_USER: '',
        LAST_USER: '',
        pictureUrl: '',
        pictureUrlPreview: ''
      },
      formUpdateItem: {
        title: '',
        pictureUrl: ''
      },
      rules: {
        numberRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: (value) => value.length <= 10 || 'Max 10 characters',
        IDcardRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: (value) => !!value || 'กรุณากรอกข้อมูล.',
        counterIDcard: (value) => value.length <= 13 || 'Max 13 characters',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'เลขที่กิจกรรม', value: 'activityId' },
        { text: 'หัวข้อ', value: 'title' },
        { text: 'ประเภท', value: 'type' },
        { text: 'ทำซ้ำ', value: 'repeats' },
        { text: 'รวม', value: 'quota' },
        { text: 'ใช้แล้ว', value: 'countUse' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      ProductExchangeRate: [],
      dataItem: [],
      dataItemViewLot: [],
      answerTypeList: [
        'คำตอบแบบข้อความ',
        'คำตอบแบบ 1 ตัวเลือก',
        'คำตอบแบบมากกว่า 1 ตัวเลือก'
      ],
      dataBranch: [],
      validAdd: true,
      validAddLot: true,
      validUpdate: true,
      dailogViewRedeem: false,
      statusViewRedeem: false,
      loadingInsert: false,
      // End Data Table Config
      //   loading
      loadingAdd: false,
      loadingEdit: false,
      required: [
        v => !!v || 'กรุณากรอกข้อมูล'
      ]
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getDataBranch()
    // this.getProductExchangeRate()
    this.dataReady = false
    // this.flex2html('flex1', {'type': 'flex', 'altText': 'Flex Message', 'contents': {'type': 'bubble', 'hero': {'type': 'image', 'url': 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/01_1_cafe.png', 'size': 'full', 'aspectRatio': '20:13', 'aspectMode': 'cover', 'action': {'type': 'uri', 'uri': 'http://linecorp.com/'}}, 'body': {'type': 'box', 'layout': 'vertical', 'contents': [{'type': 'text', 'text': 'Brown Cafe', 'weight': 'bold', 'size': 'xl'}, {'type': 'box', 'layout': 'baseline', 'margin': 'md', 'contents': [{'type': 'icon', 'size': 'sm', 'url': 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png'}, {'type': 'icon', 'size': 'sm', 'url': 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png'}, {'type': 'icon', 'size': 'sm', 'url': 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png'}, {'type': 'icon', 'size': 'sm', 'url': 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png'}, {'type': 'icon', 'size': 'sm', 'url': 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gray_star_28.png'}, {'type': 'text', 'text': '4.0', 'size': 'sm', 'color': '#999999', 'margin': 'md', 'flex': 0}]}, {'type': 'box', 'layout': 'vertical', 'margin': 'lg', 'spacing': 'sm', 'contents': [{'type': 'box', 'layout': 'baseline', 'spacing': 'sm', 'contents': [{'type': 'text', 'text': 'Place', 'color': '#aaaaaa', 'size': 'sm', 'flex': 1}, {'type': 'text', 'text': 'Miraina Tower, 4-1-6 Shinjuku, Tokyo', 'wrap': true, 'color': '#666666', 'size': 'sm', 'flex': 5}]}, {'type': 'box', 'layout': 'baseline', 'spacing': 'sm', 'contents': [{'type': 'text', 'text': 'Time', 'color': '#aaaaaa', 'size': 'sm', 'flex': 1}, {'type': 'text', 'text': '10:00 - 23:00', 'wrap': true, 'color': '#666666', 'size': 'sm', 'flex': 5}]}]}]}, 'footer': {'type': 'box', 'layout': 'vertical', 'spacing': 'sm', 'contents': [{'type': 'button', 'style': 'link', 'height': 'sm', 'action': {'type': 'uri', 'label': 'CALL', 'uri': 'https://linecorp.com'}}, {'type': 'button', 'style': 'link', 'height': 'sm', 'action': {'type': 'uri', 'label': 'WEBSITE', 'uri': 'https://linecorp.com'}}, {'type': 'spacer', 'size': 'sm'}], 'flex': 0}}})
    // Get Data
    this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
    // this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId + '&status=waiting')
    // console.log('xxxx', this.dataItem)
  },
  methods: {
    toggleMarker (item2, item) {
      this.formAdd.answerChoice.map((a) => {
        if (a === item) {
          a.splice(item2, 1)
        }
      })
    },
    addChoice (item) {
      item.push('')
      console.log(item)
    },
    addQuestion () {
      this.formAdd.answerChoice.push(['', '', ''])
      console.log('ddddd', this.formAdd.answerChoice)
    },
    chooseImage () {
      this.$refs.fileInput.click()
    },
    onSelectFile () {
      const input = this.$refs.fileInput
      this.filesAdd = input.files
      if (this.filesAdd) {
        console.log('เข้า')
        this.formAdd.pictureUrlPreview = URL.createObjectURL(this.filesAdd[0])
      } else {
        this.formAdd.pictureUrlPreview = ''
      }
      this.$forceUpdate()
      console.log('kkkk', this.formAdd.pictureUrlPreview)
      // if (files && files[0]) {
      //   const reader = new FileReader()
      //   reader.onload = e => {
      //     this.formUpdate.pictureUrlPreview = e.target.result
      //   }
      //   this.formUpdate.pictureUrlPreview = reader.readAsDataURL(files[0])
      //   this.$emit('input', files[0])
      //   console.log(this.formUpdate.pictureUrlPreview)
      // }
    },
    changColor (item) {
      console.log(item)
      this.selectType.map((a) => {
        a.text === item.text ? (a.color = '#1b437c') : (a.color = 'grey')
      })
      console.log('this.selectType', this.selectType)
    },
    sendData (dt) {
      this.$swal({
        title: 'ต้องการ แจ้งเดือน ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      }).then(async (result) => {
        console.log(dt)
        var data = {
          shopId: dt.shopId,
          module: 'activity',
          referId: dt.activityId,
          pictureUrl: dt.pictureUrl,
          message: dt.title,
          CREATE_USER: this.session.data.userName,
          LAST_USER: this.session.data.userName
        }
        await axios
          .post(
            // eslint-disable-next-line quotes
            this.DNS_IP + "/broadcast/add",
            data
          )
          .then(async (response) => {
            console.log('addDataGlobal DNS_IP + PATH + "add"', response)

            this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log(error)
            this.$router.push(
              '/system/Errorpage?returnLink=' + this.returnLink
            )
            this.dataReady = true
          })
      })
    },
    selectImgUpdate (event) {
      if (this.filesUpdate) {
        this.formUpdate.pictureUrlPreview = URL.createObjectURL(
          this.filesUpdate
        )
      } else {
        this.formUpdate.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    async selectImg (event) {
      if (this.filesAdd) {
        this.formAdd.pictureUrlPreview = await URL.createObjectURL(this.filesAdd)
        this.formAdd.title = 'd'
      } else {
        this.formAdd.pictureUrlPreview = ''
      }
      // console.log(event)
    },
    chkTypeVideo () {
      if (this.formAdd.type === 'video') {
        this.formAdd.repeats = 'OneTime'
      }
    },
    chkTypeCoin () {
      if (this.formAdd.type === 'LuckyDraw') {
        this.formAdd.coin = 0
      }
    },
    chkTypeFiled () {
      if (this.formAdd.type !== 'กรอกข้อมูล') {
        // this.formAdd.coin = 0
        this.formAdd.field1Title = ''
        this.formAdd.field1Type = ''
        this.formAdd.field2Title = ''
        this.formAdd.field2Type = ''
        this.formAdd.field3Title = ''
        this.formAdd.field3Type = ''
        this.formAdd.field4Title = ''
        this.formAdd.field4Type = ''
        this.formAdd.Primary_field = ''
      }
    },
    async getDataBranch () {
      // Clear Data ทุกครั้ง
      this.dataBranch = []
      // console.log('getDataCompany')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/master_branch/' +
            'get?shopId=' +
            this.session.data.shopId,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masBranchName
            s.text = d.masBranchName
            d = s
            this.dataBranch.push(d)
          }
          console.log('getDataCompany : ', this.dataBranch)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          console.log(error)
        })
    },
    // validate (Action) {
    //   switch (Action) {
    //     case 'ADD':
    //       this.$nextTick(() => {
    //         let self = this
    //         self.$refs.form_add.validate()
    //       })
    //       break
    //     case 'ADDLOT':
    //       this.$nextTick(() => {
    //         let self = this
    //         self.$refs.form_addLot.validate()
    //       })
    //       break
    //     case 'UPDATE':
    //       this.$nextTick(() => {
    //         let self = this
    //         self.$refs.form_update.validate()
    //       })
    //       break

    //     default:
    //       break
    //   }
    // },
    async searchDataAll () {
      //
      //
      // สำหรับ ค้นหาแบบ LIKE Search
      // ต้องระบุ Field ที่จะส่งไปให้ตรงกับ Model
      //
      var search =
        '?id=' +
        this.searchAll +
        '&productExchangeRateId=' +
        this.searchAll +
        '&amount=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
    },
    async getDataById (item) {
      console.log(item)
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'activityId',
        item.activityId,
        this.returnLink
      )
      this.formUpdate.pictureUrlPreview = this.formUpdate.pictureUrl
    },
    async addData () {
      if (this.$refs.form_add.validate()) {
      // JSON.stringify(this.formAdd.answerChoice).trim().replace(/(\r\n|\n|\r)/gm, '').replace(/'/g, "\\'").replace(/%/g, '%%')

        if (this.formAdd.type === 'กรอกข้อมูล') {
          this.formAdd.repeats = 'OneTime'
        } else {
          this.formAdd.answerChoice = null
          this.formAdd.answerType = null
          console.log('ไม่ใข่รอกข้อมูล', this.formAdd)
        }
        await this.callApiAddData()
      } else {
        console.log('ไม่ผ่าน')
      }
    },
    async callApiAddData () {
      // this.dataReady = false
      // this.dataShowQR = false

      // console.log('api', this.formAdd)
      // this.formAdd.answerChoice = [['', '', '']]
      // console.log('this.formAdd.answerChoice', this.formAdd)
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.loadingInsert = true
          this.loadingAdd = true
          const today = new Date()
          // console.log(today)
          const date =
            today.getFullYear() +
            '' +
            (today.getMonth() + 1) +
            '' +
            today.getDate()
          const time =
            today.getHours() +
            '' +
            today.getMinutes() +
            '' +
            today.getSeconds()
          const activityId = 'ACT_' + date + '' + time
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          this.formAdd.activityId = activityId
          // this.formAdd.token = tokenKey
          // this.formAdd.statusLot = 'no'
          this.formAdd.shopId = this.$session.getAll().data.shopId
          const _this = this
          let params = new FormData()
          params.append('file', this.filesAdd[0])

          await axios
            .post(this.DNS_IP + `/file/upload/activity`, params)
            .then(function (response) {
              _this.formAdd.pictureUrl = response.data
              console.log('url Pic', response.data)
            })
          delete this.formAdd['pictureUrlPreview']
          console.log('stringify1', this.formAdd.answerChoice)
          if (this.formAdd.answerType === 'คำตอบแบบ 1 ตัวเลือก' || this.formAdd.answerType === 'คำตอบแบบมากกว่า 1 ตัวเลือก') {
            this.formAdd.answerChoice = JSON.stringify(this.formAdd.answerChoice).trim().replace(/(\r\n|\n|\r)/gm, '').replace(/'/g, "\\'").replace(/%/g, '%%')
            console.log('stringify2', this.formAdd.answerChoice)
          } else {
            this.formAdd.answerChoice = null
          }
          console.log('stringify3', this.formAdd.answerChoice)
          console.log('this.formAdd', this.formAdd)
          // this.formAdd.qrCodeURL = 'http://localhost:8081/collect?token=' + this.formAdd.token
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "add",
              this.formAdd
              //   {
              //     headers: {
              //       'Application-Key': this.$session.getAll().ApplicationKey
              //     }
              //   }
            )
            .then(async (response) => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog

              console.log(this.formAdd)
              console.log('stringify4', this.formAdd.answerChoice)
              // this.dataShowQR = true
              // this.dialogViewAdd = true

              // Load Data
              console.log('this.formAdd.answerChoice', this.formAdd.answerChoice)
              await this.clearDataAdd()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingAdd = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },

    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.loadingEdit = true
          // this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.activityId
          this.formUpdateItem.title = this.formUpdate.title
          this.formUpdateItem.LAST_USER = this.session.data.userName
          if (this.filesUpdate) {
            const _this = this
            let params = new FormData()
            params.append('file', this.filesUpdate)

            await axios
              .post(this.DNS_IP + `/file/upload/activity`, params)
              .then(function (response) {
                _this.formUpdateItem.pictureUrl = response.data
                console.log('url Pic', response.data)
              })
          } else {
            this.formUpdateItem.pictureUrl = this.formUpdate.pictureUrlPreview
          }
          // delete this.formUpdate['pictureUrlPreview']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + ID,
              this.formUpdateItem
              // {
              //   headers: {
              //     'Application-Key': this.$session.getAll().ApplicationKey
              //   }
              // }
            )
            .then(async (response) => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.reloadData()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingEdit = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.activityId)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      //   this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.activityId,
        this.session.data.shopId,
        '',
        this.returnLink
      )
      //   console.log(this.DNS_IP,
      //     this.path)
    },
    async clearDataAdd () {
      this.loadingInsert = false
      this.dialogAdd = false
      this.formAdd.activityId = ''
      this.formAdd.title = ''
      this.formAdd.type = 'กรอกข้อมูล'
      this.formAdd.answerType = 'คำตอบแบบข้อความ'
      this.formAdd.repeats = ''
      this.formAdd.startDate = ''
      this.formAdd.endDate = ''
      this.formAdd.quota = ''
      this.formAdd.coin = 0
      this.formAdd.field1Title = ''
      this.formAdd.answerChoice = [['', '', '']]
      this.formAdd.field1Type = ''
      this.formAdd.field2Title = ''
      this.formAdd.field2Type = ''
      this.formAdd.field3Title = ''
      this.formAdd.field3Type = ''
      this.formAdd.field4Title = ''
      this.formAdd.field4Type = ''
      this.formAdd.Primary_field = ''
      this.formAdd.chkbox1 = false
      this.formAdd.chkbox2 = false
      this.formAdd.chkbox3 = false
      this.formAdd.chkbox4 = false
      this.formAdd.shopId = ''
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.pictureUrl = ''
      this.formAdd.pictureUrlPreview = ''
      this.filesAdd = null

      this.selectType = [
        {
          text: 'ตอบคำถามรับคะแนน',
          value: 'กรอกข้อมูล',
          icon: 'mdi-message-question',
          color: '#1b437c'
        },
        {
          text: 'รับคะแนน ฟรี!',
          value: 'FreeCoin',
          icon: 'mdi-alpha-c-circle-outline',
          color: 'grey'
        },
        {
          text: 'วิดีโอ',
          value: 'video',
          icon: 'mdi-play-box-multiple',
          color: 'grey'
        },
        {
          text: 'Lucky Draw',
          value: 'LuckyDraw',
          icon: 'mdi-dice-multiple',
          color: 'grey'
        }
      ]
      this.$refs.form_add.resetValidation()
      // console.log('ttttt', this.formAdd)
    },
    clearData2 () {
      if (this.countQuestion === 2) {
        this.formAdd.field2Title = ''
        this.formAdd.field2Type = ''
        this.formAdd.chkbox2 = false
      } else if (this.countQuestion === 3) {
        this.formAdd.field2Title = this.formAdd.field3Title
        this.formAdd.field2Type = this.formAdd.field3Type
        this.formAdd.chkbox2 = this.formAdd.chkbox3
        this.formAdd.field3Title = ''
        this.formAdd.field3Type = ''
        this.formAdd.chkbox3 = false
      } else if (this.countQuestion === 4) {
        this.formAdd.field2Title = this.formAdd.field3Title
        this.formAdd.field2Type = this.formAdd.field3Type
        this.formAdd.field3Title = this.formAdd.field4Title
        this.formAdd.field3Type = this.formAdd.field4Type
        this.formAdd.chkbox2 = this.formAdd.chkbox3
        this.formAdd.chkbox3 = this.formAdd.chkbox4
        this.formAdd.field4Title = ''
        this.formAdd.field4Type = ''
        this.formAdd.chkbox4 = false
      }
    },
    clearData3 () {
      if (this.countQuestion === 3) {
        this.formAdd.field3Title = ''
        this.formAdd.field3Type = ''
        this.formAdd.chkbox3 = false
      } else if (this.countQuestion === 4) {
        this.formAdd.field3Title = this.formAdd.field4Title
        this.formAdd.field3Type = this.formAdd.field4Type
        this.formAdd.chkbox3 = this.formAdd.chkbox4
        console.log('this.formAdd.field3Title', this.formAdd.field3Title)
        this.formAdd.field4Title = ''
        this.formAdd.field4Type = ''
        this.formAdd.chkbox4 = false
      }
    },
    clearData4 () {
      this.formAdd.field4Title = ''
      this.formAdd.field4Type = ''
      this.formAdd.chkbox4 = false
    }
  }
}
</script>
<style scoped>
.shopname {
  font-size: 13px;
}
.description {
  font-size: 14px;
}
.summary {
  font-size: 18px;
}
.point {
  font-size: 30px;
  font-weight: bold;
}
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  /* margin: auto auto;
    display: block; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  /* vertical-align: middle; */
}
#margin {
  margin-top: 30px;
  margin-bottom: 50px;
}
.iconja {
  font-size: 50px !important;
}
.v-card--link:focus::before {
  opacity: 0;
}
.not-activeCard {
  border-radius: 15px !important;
  text-align: center;
  background-color: #f7f8fc !important;
  border: 2px solid #f7f8fc;
  padding-bottom: 8px;
  padding-top: 8px;
}
.activeCard {
  border-radius: 15px !important;
  text-align: center;
  background-color: white;
  border: 2px solid #1b437c !important;
  padding-bottom: 8px;
  padding-top: 8px;
  transform: translateY(-10px);
  box-shadow: 0px 10px 20px 2px rgba(0, 0, 0, 0.25);
  transition: all ease 0.5s;
}
.not-activeCard:hover {
  transition: all ease 0.5s;
  transform: translateY(-5px);
  background-color: white;
}
.image-input {
  display: block;
  width: 250px;
  height: 250px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
.placeholder {
  background: #f0f0f0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Tool/Activity.vue